var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('p',[_vm._v("Name : "),_c('b',[_vm._v("John Richerd")])]),_c('p',[_vm._v("Code : "),_c('b',[_vm._v("#1245")])]),_c('p',[_vm._v("Job Type : "),_c('b',[_vm._v("UI Development")])])])])
}]

export { render, staticRenderFns }